import { Component, OnInit, Input } from '@angular/core';

import { trackById } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'cnc-rfq-details-kit-items',
  templateUrl: './rfq-details-kit-items.component.html',
  styleUrls: ['./rfq-details-kit-items.component.scss'],
})
export class RfqDetailsKitItemsComponent implements OnInit {
  @Input() kitItems :any[];

  trackById = trackById;

  ngOnInit() :void {
    this.formatItems();
  }

  private formatItems() :void {
    this.kitItems.forEach((item) => {
      item.total = item.quantity * item.price;
    });
  }
}
